import "./styles/main.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./installApp.js";

import { Router } from "./shared/router/Router.js";
import { LcapiiService } from "./shared/services/LcapiiService.js";
import { RegistroService } from "./shared/services/RegistroService.js";
import { Loading } from "./shared/ui/ui.js";

// Arranque:
//   1. capturar los tokens si venimos del login central
//   2. validar la sesión (con la ventana de gracia si no hay red)
//   3. traer los permisos
//   4. despachar lo que haya quedado sin registrar
//   5. arrancar el router

const initApp = async () => {
  Loading();
  try {
    LcapiiService.capturarTokensDelHash();

    const estado = await LcapiiService.establecerSesion();
    if (estado === "sin-sesion") {
      LcapiiService.redirigirALogin();
      return;
    }

    await LcapiiService.cargarPermisos();

    // Sin bloquear el arranque: si hay pendientes de una caída anterior, se van
    // enviando mientras el usuario ya puede trabajar.
    RegistroService.despacharPendientes().catch(() => {});
    RegistroService.escucharConexion();

    new Router().init();
  } finally {
    Loading(false);
  }
};

document.addEventListener("DOMContentLoaded", initApp);
